var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdown = function SvgDropdown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-24": 15,
    viewBox: "0 0 15 9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.964.29a.51.51 0 0 0-.46-.29h-14a.5.5 0 0 0-.38.83l7 8a.51.51 0 0 0 .76 0l7-8a.51.51 0 0 0 .08-.54"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export default ForwardRef;